var path = 'public/app/plugins/panel/graph/tab_time_regions.html';
var html = "<graph-time-region-form panel-ctrl=ctrl></graph-time-region-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;